import { render, staticRenderFns } from "./channelList.vue?vue&type=template&id=38648114&scoped=true"
import script from "./channelList.vue?vue&type=script&lang=ts"
export * from "./channelList.vue?vue&type=script&lang=ts"
import style0 from "./channelList.vue?vue&type=style&index=0&id=38648114&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38648114",
  null
  
)

export default component.exports